module.exports = __webpack_public_path__ + "img/spinner.702bf918.png";